import React from 'react';
import { findDOMNode } from 'react-dom';
import cx from 'classnames';

const _content = () => document.getElementById('content');

class Sticky extends React.Component<IStickyProps, {}> {
  container: any = void 0;
  state = {
    isSticky: false,
    width: 0,
    left: 0,
    height: 0,
  };

  onWindowScroll = () => {
    const isSticky = this.containerOffsetTop <= 0;
    if (isSticky !== this.state.isSticky) this.setState({ isSticky });
  };

  componentDidMount() {
    this.updateSizes();
    _content().addEventListener('scroll', this.onWindowScroll, true);
  }

  componentWillUnmount() {
    _content().removeEventListener('scroll', this.onWindowScroll);
  }

  setContainer = (ref) => {
    if (!ref || this.container) return;
    this.container = ref;
  };

  updateSizes() {
    if (!this.container) return;
    const { width, left, height } = this.container.getBoundingClientRect();
    this.setState({ width, left, height });
  }

  get containerOffsetTop() {
    return this.container.getBoundingClientRect().top - (this.props.top || 0);
  }

  get containerOffsetBottom() {
    return (
      this.container.getBoundingClientRect().bottom - (this.props.bottom || 0)
    );
  }

  get styles() {
    const { isSticky, width, left, height } = this.state;
    const {
      top,
      offsetTop,
      stickyRootStyle = {},
      stickyElementStyle = {},
    } = this.props;

    return {
      root: (isSticky && { ...stickyRootStyle, height }) || {},
      children:
        (isSticky && {
          ...stickyElementStyle,
          zIndex: 4,
          position: 'fixed',
          width: `${width}px`,
          top: `${offsetTop || top}px`,
          left: `${left}px`,
        }) ||
        {},
    };
  }

  render() {
    const { children, stickyClass } = this.props;
    const { isSticky } = this.state;

    return (
      <div ref={this.setContainer} style={this.styles.root}>
        <div
          style={this.styles.children}
          className={cx(isSticky && stickyClass)}
        >
          {children}
        </div>
      </div>
    );
  }
}
export interface IStickyProps {
  children?: React.ReactNode;
  stickyClass: string;
  top?: number;
  bottom?: number;
  offsetTop?: number;
  stickyRootStyle?: object;
  stickyElementStyle?: object;
}

export default Sticky;
